export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-700italic-7d8125ff7f707231fd89d9d7109deadf.woff2";